import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=b5bd669e&scoped=true&"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=b5bd669e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5bd669e",
  null
  
)

export default component.exports